export const TIMELINE_CONSTANTS = {
  MARGIN: { top: 50, right: 40, bottom: 80, left: 180 },
  ROW_HEIGHT: 70,
  OVERVIEW_HEIGHT: 50,
  OVERVIEW_GAP: 10,
  TOP_AXIS_INCREMENT_MINUTES: 20,
  JOB_MIN_WIDTH: 20,
  JOB_PADDING: 4,
  DEFAULT_CONTAINER_WIDTH: 1400,
} as const

export const UNASSIGNED_ROW_ID = '__unassigned__'

export const TIMELINE_COLORS = {
  ROW_BACKGROUND: '#E5F4F2',
  UNASSIGNED_ROW_BACKGROUND: '#F8FAFC',
  ROW_STROKE: '#A9D0CD',
  GRID_LINE: '#e5e7eb',
  GRID_PATH: '#d1d5db',
  CURRENT_TIME: '#DC2626',
  JOB_BORDER_NORMAL: '#01636A',
  TEXT_PRIMARY: '#111827',
  TEXT_SECONDARY: '#6b7280',
  TEXT_CONFLICT: '#DC2626',
  DRAG_HIGHLIGHT: '#014F55',
  TEXT_ON_JOB: '#FFFFFF',
  BREAK_TINT: '#F57373',
} as const
